import React, { useEffect, useState } from 'react';
import { Table } from 'antd';

const FeatureLcienseTable = (props) => {
    const { pricingFeatureData, formData } = props;
    const  [dataSource ,setDataSource] = useState([])

    useEffect(()=>{
        setDataSource(pricingFeatureData)

    },[pricingFeatureData])

 

    // Helper to format currency
    const formatCurrency = (value) => {
        return value
            ? `$${Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            : '$0.00';
    };

    const formatPercentage= (value) => {
        return value
            ? `${Number(value * 100).toFixed(1)}%`
            : '0.00%';
    };

      const getTitle = (title) => {
            if (title == 'Lincoln Power Supply')
                return 'Lincoln PS'
            else if (title == 'Fronius Power Supply')
                return 'Fronius TPSi'
            else if (title == 'Zone to Zone Ramping')
                return 'Zone Ramping'
            else if (title == 'Zone to Zone Ramping')
                return 'Zone Ramping'
            else if (title == 'Touch ramp')
                return 'Touch'
            else
                return title
        }

    // Define columns for the Table component
    const columns = [
        {
            title: <div style={{ textAlign: 'center' }}>Welding System</div>,
            dataIndex: 'Welding',
            key: 'Welding',
           // width: '10%',

        },

        {
            title: <div style={{ textAlign: 'center' }}>License</div>,
            dataIndex: 'License',
            key: 'License',
            align: 'Left',
           // width: '10%',
            render: (value) => getTitle(value),
        },
        {
            title: 'Quantity',
            dataIndex: 'Quantity',
            key: 'Quantity',
            align: 'center',
          //  width: '10%',
           // render: (value) => formatCurrency(value),
        },
        {
            title: ' License Duration',
            dataIndex: 'Duration',
            key: 'Duration',
            align: 'center',
           // width: '10%',
           // render: (value) => formatCurrency(value),
        },
        {
            title: 'Duration Discount',
            dataIndex: 'Duration_discount',
            key: 'GrandTotal',
            align: 'center',
          //  width: '10%',
            render: (value) => formatPercentage(value),
        },
        {
            title: 'Tier Discount',
            dataIndex: 'Tier_discount',
            key: 'Tier_discount',
            align: 'center',
          //  width: '10%',
          render: (value) => formatPercentage(value),
        },
        {
            title: 'Unit Sale Price',
            dataIndex: 'Unit_Lic_price_tier_disc',
            key: 'Unit_Lic_price_tier_disc',
            align: 'center',
           // width: '10%',
            render: (value) => formatCurrency(value),
        },
        {
            title: 'Total Sale Price',
            dataIndex: 'Total_lic_price',
            key: 'Total_lic_price',
            align: 'center',
           // width: '10%',
            render: (value) => formatCurrency(value),
        },


    ];

    return (
        <>
            <Table
                style={{ width: '100%', paddingLeft: '0%',}}
                className='feature-license-pricing-table'
                //   className="h-100 pipeline-table equip_table equipPaginationTable"
                dataSource={dataSource}
                columns={columns}
                pagination={false}
                size="large"
                scroll={{ y: 'calc(100vh - 600px)' }}
            />
        </>
    );
};

export default FeatureLcienseTable;
